import React, { lazy, Suspense } from "react";
import Loader from "./../components/loader.js";
import { ALL_CONSTANTS } from "../constants/displayConstants";
// import NLI_CONSTANTS from "../Products/nli/data/urlPathConstants.js";
import withLazyAndSuspense from "../utils/lazy.js";
import getServiceNameFromPath from "./mapping.js";
import { customLoadable } from "../utils/appUtils";

const pathName = window.location.pathname;
const serviceName = getServiceNameFromPath(pathName);
const Options = withLazyAndSuspense(() =>
  import("@src/Products/userVerification/chooseOptions")
);
const HomePage = withLazyAndSuspense(() =>
  import("@src/Products/HomeScreen/HomeScreen")
);

const componentToRender = (pathName) => {
  if (
    pathName === ALL_CONSTANTS.DUE_PATH ||
    pathName === ALL_CONSTANTS.DUE_VERIFICATION_PATH
  ) {
    return Options;
  } else {
    return HomePage;
  }
};

const LazyLoadedTablescreen = lazy(() =>
  import("../Products/Updatedscreen/TableScreen")
);
const Tablescreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedTablescreen {...props} />
    </Suspense>
  );
};

const LazyLoadedRekycNochange = lazy(() =>
  import("../Products/rekyc/UpdateRekyc/detailsAccordian.web.js")
);
const RekycNochange = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedRekycNochange {...props} />
    </Suspense>
  );
};

const LazyLoadedDiscrepantDocumentsHome = lazy(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentHome")
);
const DiscrepantDocumentsHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDiscrepantDocumentsHome {...props} />
    </Suspense>
  );
};
const LazyLoadedDiscrepantDocumentsAuthentication = lazy(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentAuth")
);
const DiscrepantDocumentsAuthentication = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDiscrepantDocumentsAuthentication {...props} />
    </Suspense>
  );
};
const LazyLoadedDiscrepantDocumentsSuccess = lazy(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentSuccess")
);

const DiscrepantDocumentsSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDiscrepantDocumentsSuccess {...props} />
    </Suspense>
  );
};

const Verification = withLazyAndSuspense(() =>
  import("../Products/Newhomescreen/Verification")
);

const DownTime = withLazyAndSuspense(() =>
  import('../Products/Errorpage/Downtime/downtimeScreen.js'),
);

const NewDueVerification = withLazyAndSuspense(() =>
  import("../Products/OverDue/newVerification.js")
);

const LazyLoadedValidateUrl = lazy(() =>
  import("../Products/Newhomescreen/validateUrl.js")
);

const ValidateUrl = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedValidateUrl {...props} />
    </Suspense>
  );
};

const LazyLoadedPanNumber = lazy(() =>
  import("../Products/userVerification/panNumber")
);
const PanNumber = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPanNumber {...props} />
    </Suspense>
  );
};

const LazyLoadedAdhaarNumber = lazy(() =>
  import("../Products/userVerification/aadharNumber")
);
const AdhaarNumber = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedAdhaarNumber {...props} />
    </Suspense>
  );
};

const LazyLoadedDOB = lazy(() =>
  import("../Products/userVerification/dob/index")
);
const DOB = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDOB {...props} />
    </Suspense>
  );
};

const LazyLoadedOtpScreen = lazy(() =>
  import("../Products/OtpScreen/OtpScreen")
);

const OtpScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedOtpScreen {...props} />
    </Suspense>
  );
};

const LazyLoadedAadharOtpscreen = lazy(() =>
  import("../Products/OtpScreen/aadharOtpscreen")
);
const AadharOtpscreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedAadharOtpscreen {...props} />
    </Suspense>
  );
};
const LazyLoadedDualAuth = lazy(() =>
  import("../Products/Updatedscreen/dualAuth")
);
const DualAuth = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDualAuth {...props} />
    </Suspense>
  );
};
const LazyLoadedMobileScreen = lazy(() =>
  import("../Products/Mobilescreen/MobileScreen")
);
const MobileScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedMobileScreen {...props} />
    </Suspense>
  );
};
const LazyLoadedUpdatedscreen = lazy(() =>
  import("../Products/Updatedscreen/Updatedscreen")
);
const Updatedscreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedUpdatedscreen {...props} />
    </Suspense>
  );
};
const LazyLoadedFeedback = lazy(() =>
  import("../Products/nli/services/feedbackNLI/feedback")
);
const Feedback = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedFeedback {...props} />
    </Suspense>
  );
};
const LazyLoadedFeedbackExp = lazy(() =>
  import("../Products/nli/services/feedbackNLI/feedSelect")
);
const FeedbackExp = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedFeedbackExp {...props} />
    </Suspense>
  );
};

const LazyLoadedFeedbackRec = lazy(() =>
  import("../Products/nli/services/feedbackNLI/feedbackRec")
);

const FeedbackRec = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedFeedbackRec {...props} />
    </Suspense>
  );
};
const LazyLoadedLoanTracker = lazy(() =>
  import("../Products/nli/services/loanTracker/loanTracker.js")
);
const LoanTracker = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedLoanTracker {...props} />
    </Suspense>
  );
};
const LazyLoadedNLIError = lazy(() =>
  import("../Products/nli/components/nliErrorPage")
);
const NLIError = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedNLIError {...props} />
    </Suspense>
  );
};
const LazyLoadedNLISuccess = lazy(() =>
  import("../Products/nli/components/nliSuccessPage")
);

const NLISuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedNLISuccess {...props} />
    </Suspense>
  );
};
const LazyLoadedNLIDuplicateSuccess = lazy(() =>
  import("../Products/nli/components/nliDuplicateSuccessPage")
);

const NLIDuplicateSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedNLIDuplicateSuccess {...props} />
    </Suspense>
  );
};

const Update = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/update")
);

const LazyLoadedUpdateData = lazy(() =>
  import("../Products/Updatedscreen/updateData")
);
const UpdateData = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedUpdateData {...props} />
    </Suspense>
  );
};
const LazyLoadedDetails = lazy(() =>
  import("../Products/Updatedscreen/details")
);

const Details = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDetails {...props} />
    </Suspense>
  );
};

const LazyLoadedErrorPage = lazy(() =>
  import("../Products/Updatedscreen/errorPage")
);

const ErrorPage = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedErrorPage {...props} />
    </Suspense>
  );
};

const LazyLoadedsessionExipry = lazy(() =>
  import("../Products/HomeScreen/sessionExpired")
);

const sessionExipry = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedsessionExipry {...props} />
    </Suspense>
  );
};

const LazyLoadedTransactionerrorpage = lazy(() =>
  import("../Products/Updatedscreen/transactionError")
);
const Transactionerrorpage = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedTransactionerrorpage {...props} />
    </Suspense>
  );
};

const LazyLoadedTransactionSuccess = lazy(() =>
  import("../Products/Updatedscreen/transactionSuccess")
);
const TransactionSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedTransactionSuccess {...props} />
    </Suspense>
  );
};
const LazyLoadedSettelmentPayStatus = lazy(() =>
  import("../Products/OverDue/settlementPayStatus")
);

const SettelmentPayStatus = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedSettelmentPayStatus {...props} />
    </Suspense>
  );
};
// Overdue Screens
const LazyLoadedOverdueDetails = lazy(() =>
  import("../Products/OverDue/OverdueDetails")
);
const OverdueDetails = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedOverdueDetails {...props} />
    </Suspense>
  );
};

const LazyLoadedNewOverdue = lazy(() =>
  import("@src/Products/OverDue/newOverdueScreen")
);

const NewOverdue = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedNewOverdue {...props} />
    </Suspense>
  );
};

//Overdue Payment Status
const LazyLoadedOverduePayStatus = lazy(() =>
  import("../Products/OverDue/overduePayStatus")
);
const OverduePayStatus = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedOverduePayStatus {...props} />
    </Suspense>
  );
};
const LazyLoadedDiyErrorPage = lazy(() =>
  import("../Products/OverDue/diyErrorPage.js")
);
const DiyErrorPage = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDiyErrorPage {...props} />
    </Suspense>
  );
};
const LazyLoadedAccountNo = lazy(() =>
  import("../Products/AccountNo/AccountNo")
);
const AccountNo = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedAccountNo {...props} />
    </Suspense>
  );
};

const LazyLoadedlayout = lazy(() =>
  import("../Products/InternalComponents/layout")
);
const layout = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedlayout {...props} />
    </Suspense>
  );
};

const LazyLoadedUpdatePan = lazy(() =>
  import("../Products/Updatedscreen/updatePan")
);
const UpdatePan = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedUpdatePan {...props} />
    </Suspense>
  );
};

const LazyLoadedUpdateEmail = lazy(() =>
  import("../Products/Updatedscreen/updateEmail")
);
const UpdateEmail = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedUpdateEmail {...props} />
    </Suspense>
  );
};

const LazyLoadedUpdateUsername = lazy(() =>
  import("../Products/Updatedscreen/updateUsername")
);
const UpdateUsername = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedUpdateUsername {...props} />
    </Suspense>
  );
};

const LazyLoadederrorpage = lazy(() =>
  import("../Products/Errorpage/errorpage")
);
const errorpage = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadederrorpage {...props} />
    </Suspense>
  );
};

const LazyLoadedOverDueScreen = lazy(() =>
  import("../Products/OverDue/OverDueScreen")
);
const OverDueScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedOverDueScreen {...props} />
    </Suspense>
  );
};
const LazyLoadedPayAmount = lazy(() => import("../Products/OverDue/payAmount"));
const PayAmount = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPayAmount {...props} />
    </Suspense>
  );
};

const LazyLoadediAgreePage = lazy(() =>
  import("../Products/termsNcondition/termsNcondition")
);
const iAgreePage = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadediAgreePage {...props} />
    </Suspense>
  );
};
const LazyLoadedConfirmManager = lazy(() =>
  import("../Products/userVerification/confirmManager")
);
const ConfirmManager = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedConfirmManager {...props} />
    </Suspense>
  );
};
const LazyLoadedConfirmCustomer = lazy(() =>
  import("../Products/userVerification/confirmCustomer")
);
const ConfirmCustomer = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedConfirmCustomer {...props} />
    </Suspense>
  );
};
const LazyLoadedverifyUser = lazy(() =>
  import("../Products/Updatedscreen/verifyUser")
);

const verifyUser = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedverifyUser {...props} />
    </Suspense>
  );
};
//rekyc
const LazyLoadedrekyc = lazy(() => import("../Products/rekyc/rekyc"));
const rekyc = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedrekyc {...props} />
    </Suspense>
  );
};
const LazyLoadedrekycSuccess = lazy(() =>
  import("../Products/rekyc/rekycSuccess")
);

const rekycSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedrekycSuccess {...props} />
    </Suspense>
  );
};

const LazyLoadedRekycErrorRedirect = lazy(() =>
  import("../Products/rekyc/error.web")
);
const RekycErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedRekycErrorRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadedrekycHome = lazy(() => import("../Products/rekyc/main.web"));

const rekycHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedrekycHome {...props} />
    </Suspense>
  );
};
const LazyLoadedrekycData = lazy(() => import("../Products/rekyc/data.web"));

const rekycData = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedrekycData {...props} />
    </Suspense>
  );
};

//data quality
const LazyLoadeddataQuality = lazy(() =>
  import("../Products/dataQuality/dataQuality")
);

const dataQuality = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataQuality {...props} />
    </Suspense>
  );
};
const LazyLoadeddataQualitySuccess = lazy(() =>
  import("../Products/dataQuality/dataQualitySuccess")
);

const dataQualitySuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataQualitySuccess {...props} />
    </Suspense>
  );
};

const LazyLoadedDataQualityErrorRedirect = lazy(() =>
  import("../Products/dataQuality/error.web")
);

const CancelautodebitTable = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedCancelautodebitTable {...props} />
    </Suspense>
  );
};
const LazyLoadedCancelautodebitTable = lazy(() =>
  import(
    "../Products/Updatedscreen/Cancelautodebitmandate/CancelautodebitTable"
  )
);

const DataQualityErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDataQualityErrorRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadeddataQualityHome = lazy(() =>
  import("../Products/dataQuality/main.web")
);

const dataQualityHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataQualityHome {...props} />
    </Suspense>
  );
};

const LazyLoadeddataQualityData = lazy(() =>
  import("../Products/dataQuality/data.web")
);

const dataQualityData = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataQualityData {...props} />
    </Suspense>
  );
};

const LazyLoadeddataQualityRemovedVflowSuccess = lazy(() =>
  import("../Products/dataQuality/components/Success.web")
);

const dataQualityRemovedVflowSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataQualityRemovedVflowSuccess {...props} />
    </Suspense>
  );
};

//Dual residency
const LazyLoadeddualResidency = lazy(() =>
  import("../Products/DualResidency/dualRes")
);

const dualResidency = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddualResidency {...props} />
    </Suspense>
  );
};

const LazyLoadeddualResidencyHome = lazy(() =>
  import("../Products/DualResidency/main.web")
);

const dualResidencyHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddualResidencyHome {...props} />
    </Suspense>
  );
};

const LazyLoadedDualresidencyErrorRedirect = lazy(() =>
  import("../Products/DualResidency/components/error.web")
);

const DualresidencyErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDualresidencyErrorRedirect {...props} />
    </Suspense>
  );
};

// Data govenance
const LazyLoadeddataGovernance = lazy(() =>
  import("../Products/DataGovernance/dgov")
);

const dataGovernance = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataGovernance {...props} />
    </Suspense>
  );
};

const LazyLoadeddataGovernanceHome = lazy(() =>
  import("../Products/DataGovernance/main.web")
);

const dataGovernanceHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddataGovernanceHome {...props} />
    </Suspense>
  );
};

const LazyLoadedDatagovernanceErrorRedirect = lazy(() =>
  import("../Products/DataGovernance/components/error.web")
);

const DatagovernanceErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDatagovernanceErrorRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadedDatagovernanceSuccessRedirect = lazy(() =>
  import("../Products/DataGovernance/components/success.web")
);

const DatagovernanceSuccessRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDatagovernanceSuccessRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadeddemog = lazy(() =>
  import("../Products/pebble/services/DemographicUpdation/index")
);

const demog = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadeddemog {...props} />
    </Suspense>
  );
};

const LazyLoadedpqOffer = lazy(() =>
  import("../Products/OverDue/PqOffer/pqOffer.web")
);

const pqOffer = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedpqOffer {...props} />
    </Suspense>
  );
};

const LazyLoadedPebbleErrorScreen = lazy(() =>
  import("../Products/pebble/pebbleErrorScreen")
);

const PebbleErrorScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPebbleErrorScreen {...props} />
    </Suspense>
  );
};

const LazyLoadedpayslip = lazy(() =>
  import("../Products/pebble/services/Payslip/payslip")
);

const payslip = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedpayslip {...props} />
    </Suspense>
  );
};

const LazyLoadedVariant = lazy(() =>
  import("../Products/pebble/services/VariantMigration/index")
);

const Variant = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedVariant {...props} />
    </Suspense>
  );
};

const LazyLoadedSolvency = lazy(() =>
  import("../Products/pebble/services/SolvencyCertificate/index")
);

const Solvency = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedSolvency {...props} />
    </Suspense>
  );
};

const LazyLoadedBankingKyc = lazy(() =>
  import("../Products/pebble/services/BankingCertificate/index")
);

const BankingKyc = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedBankingKyc {...props} />
    </Suspense>
  );
};

const LazyLoadedEmailMobileModification = lazy(() =>
  import("../Products/pebble/services/EmailMobileModification/index")
);

const EmailMobileModification = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedEmailMobileModification {...props} />
    </Suspense>
  );
};

const LazyLoadedPebble = lazy(() => import("../Products/pebble/pebble"));

const Pebble = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPebble {...props} />
    </Suspense>
  );
};

const LazyLoadedgridAuthentication = lazy(() =>
  import("../Products/Updatedscreen/gridAutentication/gridAuthentication")
);

const gridAuthentication = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedgridAuthentication {...props} />
    </Suspense>
  );
};

const LazyLoadedGridautherrorscreen = lazy(() =>
  import("../Products/Updatedscreen/gridAutentication/Gridautherrorscreen")
);

const Gridautherrorscreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedGridautherrorscreen {...props} />
    </Suspense>
  );
};

const LazyLoadedgridAuthsuccessScreen = lazy(() =>
  import("../Products/Updatedscreen/gridAutentication/gridAuthsuccessScreen")
);

const gridAuthsuccessScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedgridAuthsuccessScreen {...props} />
    </Suspense>
  );
};

const LazyLoadedPebbleStatusRedirect = lazy(() =>
  import("../Products/rekyc/error.web")
);

const PebbleStatusRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPebbleStatusRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadedPebbleErrorRedirect = lazy(() =>
  import("../Products/DataGovernance/components/error.web")
);

const PebbleErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPebbleErrorRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadedagentLogin = lazy(() =>
  import("../Products/Updatedscreen/agentLogin")
);

const agentLogin = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedagentLogin {...props} />
    </Suspense>
  );
};

const LazyLoadedCibilTerms = lazy(() =>
  import("../Products/OverDue/cibilTerms")
);

const CibilTerms = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedCibilTerms {...props} />
    </Suspense>
  );
};

const CibilData = customLoadable(import("../Products/OverDue/cibilData"), {
  fallback: <Loader loading={true} />,
});

const LazyLoadedTermsAndConditionsWhatsApp = lazy(() =>
  import("../Products/termsNcondition/termsandcondition")
);

const TermsAndConditionsWhatsApp = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedTermsAndConditionsWhatsApp {...props} />
    </Suspense>
  );
};

const LazyLoadedVehicleValuation = lazy(() =>
  import("../Products/carDekho/vehicleValuation")
);

const VehicleValuation = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedVehicleValuation {...props} />
    </Suspense>
  );
};

const LazyLoadedVehicleDetails = lazy(() =>
  import("../Products/carDekho/vehicleDetails")
);

const VehicleDetails = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedVehicleDetails {...props} />
    </Suspense>
  );
};

const LazyLoadedCardekholastscreen = lazy(() =>
  import("../Products/Newhomescreen/Cardekholastscreen")
);

const Cardekholastscreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedCardekholastscreen {...props} />
    </Suspense>
  );
};

const LazyLoadedCarDetails = lazy(() =>
  import("../Products/carDekho/carDetails")
);

const CarDetails = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedCarDetails {...props} />
    </Suspense>
  );
};

const LazyLoadedredirectHome = lazy(() =>
  import("../Products/userVerification/redirectHome")
);

const redirectHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedredirectHome {...props} />
    </Suspense>
  );
};

// NLI
const LazyLoadedServiceRequest = lazy(() =>
  import("../Products/nli/services/ServiceRequest/renderServiceRequest")
);

const ServiceRequest = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedServiceRequest {...props} />
    </Suspense>
  );
};

const LazyLoadedForexSubmit = lazy(() =>
  import("../Products/nli/services/ForexInsta/renderSubmitForex")
);

const ForexSubmit = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedForexSubmit {...props} />
    </Suspense>
  );
};

const LazyLoadedPropertySearch = lazy(() =>
  import("../Products/nli/services/PropertySearch/renderPropertySearch")
);

const PropertySearch = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedPropertySearch {...props} />
    </Suspense>
  );
};

const LazyLoadedGDPRdisclaimer = lazy(() =>
  import("../Products/nli/services/GDPR/renderDis")
);

const GDPRdisclaimer = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedGDPRdisclaimer {...props} />
    </Suspense>
  );
};

const LazyLoadedGDPR = lazy(() =>
  import("../Products/nli/services/GDPR/renderGdpr")
);

const GDPR = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedGDPR {...props} />
    </Suspense>
  );
};

const LazyLoadedCustomerCheck = lazy(() =>
  import("../Products/nli/services/GDPR/renderCustomer")
);

const CustomerCheck = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedCustomerCheck {...props} />
    </Suspense>
  );
};

const LazyLoadedForexInsta = lazy(() =>
  import("../Products/nli/services/ForexInsta/renderForexInsta")
);

const ForexInsta = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedForexInsta {...props} />
    </Suspense>
  );
};

const LazyLoadedConfirmSR = lazy(() =>
  import("../Products/nli/services/ServiceRequest/renderConfirmSR")
);

const ConfirmSR = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedConfirmSR {...props} />
    </Suspense>
  );
};

const LazyLoadedQrLogin = lazy(() =>
  import("../Products/nli/services/QRCode/renderQrLogin")
);

const QrLogin = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedQrLogin {...props} />
    </Suspense>
  );
};

const LazyLoadedLoanQrLogin = lazy(() =>
  import("../Products/nli/services/LoanQRCode/loanQRCodeLogin")
);

const LoanQrLogin = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedLoanQrLogin {...props} />
    </Suspense>
  );
};

const LazyLoadedGridCardLogin = lazy(() =>
  import("../Products/nli/services/gridCardAuthentication/gridCardLogin")
);

const GridCardLogin = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedGridCardLogin {...props} />
    </Suspense>
  );
};

const LazyLoadedGridCardAuthentication = lazy(() =>
  import(
    "../Products/nli/services/gridCardAuthentication/gridAuthentication.js"
  )
);

const GridCardAuthentication = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedGridCardAuthentication {...props} />
    </Suspense>
  );
};

const LazyLoadedMultiwalletLogin = lazy(() =>
  import("../Products/nli/services/MultiwalletCard/multiWalletLogin.js")
);

const MultiwalletLogin = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedMultiwalletLogin {...props} />
    </Suspense>
  );
};

const LazyLoadedMultiwalletDash = lazy(() =>
  import("../Products/nli/services/MultiwalletCard/multiWalletDash.web")
);

const MultiwalletDash = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedMultiwalletDash {...props} />
    </Suspense>
  );
};

const LazyLoadedSettlementScreen = lazy(() =>
  import("../Products/OverDue/settlementScreen")
);

const SettlementScreen = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedSettlementScreen {...props} />
    </Suspense>
  );
};

// kyc button
const LazyLoadedkycButton = lazy(() =>
  import("../Products/kycButton/kycButton")
);

const kycButton = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButton {...props} />
    </Suspense>
  );
};

const LazyLoadedkycButtonRemovedVflowSuccess = lazy(() =>
  import("../Products/kycButton/components/Success.web")
);

const kycButtonRemovedVflowSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButtonRemovedVflowSuccess {...props} />
    </Suspense>
  );
};

const LazyLoadedkycButtonSuccess = lazy(() =>
  import("../Products/kycButton/kycButtonSuccess")
);

const kycButtonSuccess = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButtonSuccess {...props} />
    </Suspense>
  );
};

const LazyLoadedkycButtonErrorRedirect = lazy(() =>
  import("../Products/kycButton/error.web")
);

const kycButtonErrorRedirect = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButtonErrorRedirect {...props} />
    </Suspense>
  );
};

const LazyLoadedkycButtonHome = lazy(() =>
  import("../Products/kycButton/main.web")
);

const kycButtonHome = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButtonHome {...props} />
    </Suspense>
  );
};

const LazyLoadedkycButtonData = lazy(() =>
  import("../Products/kycButton/data.web")
);

const kycButtonData = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedkycButtonData {...props} />
    </Suspense>
  );
};

//kyc Button end
// * ForexCurrencyDelivery
const LazyLoadedForeignCurrencyDelivery = lazy(() =>
  import("../Products/nli/ForeignCurrencyDelivery/ForeignCurrencyDelivery")
);

const ForeignCurrencyDelivery = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedForeignCurrencyDelivery {...props} />
    </Suspense>
  );
};

// Digilocker
const LazyLoadedDigilockerService = lazy(() =>
  import('../Products/Digilocker/digilocker.js')
);

const Digilocker = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDigilockerService {...props} />
    </Suspense>
  );
};
const LazyLoadedDigilockerConsentService = lazy(() =>
  import('../Products/Digilocker/digilockerConsent.js')
);

const DigilockerConsent = (props) => {
  return (
    <Suspense fallback={<Loader loading={true} />}>
      <LazyLoadedDigilockerConsentService {...props} />
    </Suspense>
  );
};


//Quick Pay DIY

const QuickPay = withLazyAndSuspense(() =>
  import("../Products/OverDue/QuickPay/accountVerification.js")
);

const QuickPayStatus = withLazyAndSuspense(() =>
  import("../Products/OverDue/QuickPay/quickPayStatus.js")
);

const Vkyc = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/screens/VKYC.js'),
);

const m2mError = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/screens/ErrorPage.js'),
);

const MinorToMajor = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/MinorToMajor.js'),
);

const RekycNoChangeSuccess = withLazyAndSuspense(() =>
  import('../Products/rekyc/UpdateRekyc/noChangeSuccess.js'),
);

const CommonRouteMap = {
  RekycNochange: {
    component: RekycNochange,
    path: '/servicing/rekyc-nochange',
  },
  RekycNoChangeSuccess: {
    component: RekycNoChangeSuccess,
    path: '/servicing/rekyc-success',
  },
  // * minor to major
  MinorToMajor: {
    component: MinorToMajor,
    path: `/servicing/minor-to-major`,
  },
  m2mError: {
    component: m2mError,
    path: `/servicing/m2mError`,
  },
  Vkyc: {
    component: Vkyc,
    path: '/servicing/m2mVkyc',
  },

  // * ForexCurrencyDelivery
  ForeignCurrencyDelivery: {
    component: ForeignCurrencyDelivery,
    path: `/servicing/nli/foreignCurrencyDelivery`,
  },
  // digilocker
  Digilocker: {
    component: Digilocker,
    path: '/servicing/digilockerRedirect',
  },
  DigilockerConsent: {
    component: DigilockerConsent,
    path: '/servicing/digilockerConsent',
  },
  //kyc button
  kycButtonRemovedVflowSuccess: {
    component: kycButtonRemovedVflowSuccess,
    path: `/servicing/kycButtonSuccess`,
  },
  kycButton: {
    component: kycButton,
    path: `/servicing/kycb`,
  },
  kycButtonSuccess: {
    component: kycButtonSuccess,
    path: `/servicing/kycButtonRedirect`,
  },
  kycButtonHome: {
    component: kycButtonHome,
    path: `/servicing/kycButtonProcess`,
  },
  kycButtonData: {
    component: kycButtonData,
    path: `/servicing/kycButtonData`,
  },

  kycButtonErrorRedirect: {
    component: kycButtonErrorRedirect,
    path: `/servicing/kycButtonError`,
  },

  //kyc button end

  Tablescreen: {
    component: Tablescreen,
    path: `/servicing${serviceName}/tablescreen`,
  },
  CancelautodebitTable: {
    component: CancelautodebitTable,
    path: `/servicing${serviceName}/CancelautodebitTable`,
  },
  // DueVerification: {
  //   component: DueVerification,
  //   path: `/servicing${serviceName}/DueVerification`,
  // },
  Verification: {
    component:
      serviceName === ALL_CONSTANTS.DUE_URL_END
        ? NewDueVerification
        : Verification,
    path: `/servicing${serviceName}/Verification `,
  },
  //  Overdue Verification
  // NewDueVerification: {
  //   component: NewDueVerification,
  //   path: `/servicing${serviceName}/DueVerification`,
  // },
  ValidateUrl: {
    component: ValidateUrl,
    path: `/servicing/ValidateUrl`,
  },
  UpdateUsername: {
    component: UpdateUsername,
    path: `/servicing${serviceName}/updateUsername`,
  },
  UpdateEmail: {
    component: UpdateEmail,
    path: `/servicing${serviceName}/updateEmail`,
  },
  UpdatePan: {
    component: UpdatePan,
    path: `/servicing${serviceName}/updatePan`,
  },
  AccountNo: {
    component: AccountNo,
    path: `/servicing${serviceName}/accountno`,
  },
  Updatedscreen: {
    component: Updatedscreen,
    path: `/servicing${serviceName}/updated`,
  },
  Update: {
    component: Update,
    path: `/servicing${serviceName}/update`,
  },
  UpdateData: {
    component: UpdateData,
    path: `/servicing${serviceName}/preview`,
  },
  ErrorPage: {
    component: ErrorPage,
    path: `/servicing${serviceName}/error`,
  },
  DownTime: {
    component: DownTime,
    path: `/servicing/underMaintenance`,
  },
  DiyErrorPage: {
    component: DiyErrorPage,
    path: `/servicing${serviceName}/diyError`,
  },

  sessionExipry: {
    component: sessionExipry,
    path: `/servicing${serviceName}/sessionExpired`,
  },
  MobileScreen: {
    component: MobileScreen,
    path: `/servicing${serviceName}/mobileno`,
  },
  OtpScreen: {
    component: OtpScreen,
    path: `/servicing${serviceName}/otp`,
  },
  AadharOtpscreen: {
    component: AadharOtpscreen,
    path: `/servicing${serviceName}/aadharOtp`,
  },
  DOB: {
    component: DOB,
    path: `/servicing${serviceName}/dob`,
  },
  errorpage: {
    component: errorpage,
    path: `/servicing${serviceName}/error`,
  },
  Transactionerrorpage: {
    component: Transactionerrorpage,
    path: `/servicing${serviceName}/transactionError`,
  },
  TransactionSuccess: {
    component: TransactionSuccess,
    path: `/servicing${serviceName}/transactionSuccess`,
  },
  AdhaarNumber: {
    component: AdhaarNumber,
    path: `/servicing${serviceName}/aadhaarno`,
  },
  PanNumber: {
    component: PanNumber,
    path: `/servicing${serviceName}/panno`,
  },
  Options: {
    component: Options,
    path: `/servicing${serviceName}/verify`,
  },
  OverDueScreen: {
    component: OverDueScreen,
    path: `/servicing${serviceName}/overdue`,
  },

  //Overdue Screen
  NewOverdue: {
    component: NewOverdue,
    path: `/servicing${serviceName}/overdueScreen`,
  },
  OverdueDetails: {
    component: OverdueDetails,
    path: `/servicing${serviceName}/OverdueDetails`,
  },
  OverduePayment: {
    component: NewOverdue,
    path: `/servicing${serviceName}/OverduePayment`,
  },

  OverduePayStatus: {
    component: OverduePayStatus,
    path: `/servicing${serviceName}/overduePayStatus`,
  },
  //****** */

  // Quick Pay
  QuickPay: {
    component: QuickPay,
    path: `/servicing${serviceName}/quickPay`,
  },

  QuickPayStatus: {
    component: QuickPayStatus,
    path: `/servicing${serviceName}/QuickPayStatus`,
  },
  //**** */

  ConfirmManager: {
    component: ConfirmManager,
    path: `/servicing${serviceName}/confirmManager`,
  },
  ConfirmCustomer: {
    component: ConfirmCustomer,
    path: `/servicing${serviceName}/confirmCustomer`,
  },
  redirectHome: {
    component: redirectHome,
    path: `/servicing${serviceName}/redirectHome`,
  },
  PayAmount: {
    component: PayAmount,
    path: `/servicing${serviceName}/payAmount`,
  },
  TermsAndConditionsWhatsApp: {
    component: TermsAndConditionsWhatsApp,
    path: `/servicing${serviceName}/termsandcondition`,
  },

  //* Discrepant module
  DiscrepantDocumentsHome: {
    component: DiscrepantDocumentsHome,
    path: "/servicing/nli/uploadDiscrepantDocumentsHome",
  },
  DiscrepantDocumentsAuthentication: {
    component: DiscrepantDocumentsAuthentication,
    path: "/servicing/nli/uploadDiscrepantDocumentsAuthentication",
  },
  DiscrepantDocumentsSuccess: {
    component: DiscrepantDocumentsSuccess,
    path: "/servicing/nli/uploadDiscrepantDocumentSuccess",
  },

  CibilTerms: {
    component: CibilTerms,
    path: `/servicing${serviceName}/cibilTerms`,
  },
  CibilData: {
    component: CibilData,
    path: `/servicing${serviceName}/cibilData`,
  },
  VehicleValuation: {
    component: VehicleValuation,
    path: `/servicing${serviceName}/vehicleValuation`,
  },
  VehicleDetails: {
    component: VehicleDetails,
    path: `/servicing${serviceName}/vehicleDetails`,
  },
  pqOffer: {
    component: pqOffer,
    path: `/pqOffer`,
  },

  SettlementScreen: {
    component: SettlementScreen,
    path: `/settlementScreen`,
  },
  preClosure: {
    component: SettlementScreen,
    path: "/preClosure",
  },
  Cardekholastscreen: {
    component: Cardekholastscreen,
    path: `/servicing${serviceName}/cardekholeaddetails`,
  },
  CarDetails: {
    component: CarDetails,
    path: `/servicing${serviceName}/carDetails`,
  },
  DualAuth: {
    component: DualAuth,
    path: `/servicing${serviceName}/dualAuth`,
  },
  iAgreePage: {
    component: iAgreePage,
    path: `/servicing${serviceName}/termsConditions`,
  },
  verifyUser: {
    component: verifyUser,
    path: `/servicing${serviceName}/verifyUser`,
  },
  //GridAuthentication
  gridAuthentication: {
    component: gridAuthentication,
    path: `/servicing/gridAuthentication`,
  },
  gridauthErrorScreen: {
    component: Gridautherrorscreen,
    path: `/servicing/GridauthErrorScreen`,
  },
  gridAuthsuccessScreen: {
    component: gridAuthsuccessScreen,
    path: `/servicing/gridAuthSuccessScreen`,
  },
  //data quality
  dataQuality: {
    component: dataQuality,
    path: `/servicing/data-ovd`,
  },
  dataQualitySuccess: {
    component: dataQualitySuccess,
    path: `/servicing/dataQualityRedirect`,
  },
  dataQualityHome: {
    component: dataQualityHome,
    path: `/servicing/dataQualityProcess`,
  },
  dataQualityData: {
    component: dataQualityData,
    path: `/servicing/dataQualityData`,
  },

  DataQualityErrorRedirect: {
    component: DataQualityErrorRedirect,
    path: `/servicing/dataQualityError`,
  },
  dataQualityRemovedVflowSuccess: {
    component: dataQualityRemovedVflowSuccess,
    path: `/servicing/dataQualitySuccess`,
  },

  rekyc: {
    component: rekyc,
    path: `/servicing/rekyc`,
  },
  rekycSuccess: {
    component: rekycSuccess,
    path: `/servicing/rekycRedirect`,
  },
  rekycHome: {
    component: rekycHome,
    path: `/servicing/rekycProcess`,
  },
  rekycData: {
    component: rekycData,
    path: `/servicing/rekycData`,
  },
  // Data governace
  dataGovernance: {
    component: dataGovernance,
    path: `/servicing/data-governance`,
  },
  dataGovernanceHome: {
    component: dataGovernanceHome,
    path: `/servicing/data-governance-process`,
  },
  DatagovernanceErrorRedirect: {
    component: DatagovernanceErrorRedirect,
    path: `/servicing/DatagovernanceError`,
  },
  DatagovernanceSuccessRedirect: {
    component: DatagovernanceSuccessRedirect,
    path: `/servicing/DatagovernanceSuccess`,
  },
  // Data governace end

  //Dual residency
  dualResidency: {
    component: dualResidency,
    path: `/servicing/dual-Residency`,
  },
  dualResidencyHome: {
    component: dualResidencyHome,
    path: `/servicing/dual-residency-process`,
  },
  DualresidencyErrorRedirect: {
    component: DualresidencyErrorRedirect,
    path: `/servicing/DualresidencyError`,
  },
  //Dual residency end

  // Pebble
  Variant: {
    component: Variant,
    path: `/pebbledemo`,
  },
  pebble: {
    component: Pebble,
    path: `/servicing/pebble`,
  },
  variantMigration: {
    component: Variant,
    path: `/servicing/pebble-services/variant-migration`,
  },
  solvencyCertificate: {
    component: Solvency,
    path: `/servicing/pebble-services/solvency-certificate`,
  },
  bankingKyc: {
    component: BankingKyc,
    path: `/servicing/pebble-services/banking-kyc`,
  },
  email: {
    component: EmailMobileModification,
    path: `/servicing/pebble-services/email-mobile-modification`,
  },
  payslip: {
    component: payslip,
    path: `/servicing/pebble-services/payslip`,
  },
  demog: {
    component: demog,
    path: `/servicing/pebble-services/demogUpdate`,
  },
  PebbleErrorScreen: {
    component: PebbleErrorScreen,
    path: `/servicing/pebbleError`,
  },
  bankingKyc: {
    component: BankingKyc,
    path: `/servicing/pebble-services/banking-kyc`,
  },
  email: {
    component: EmailMobileModification,
    path: `/servicing/pebble-services/email-mobile-modification`,
  },
  payslip: {
    component: payslip,
    path: `/servicing/pebble-services/payslip`,
  },
  demog: {
    component: demog,
    path: `/servicing/pebble-services/demogUpdate`,
  },
  PebbleStatusRedirect: {
    component: PebbleStatusRedirect,
    path: `/servicing/pebble-logout`,
  },
  PebbleErrorRedirect: {
    component: PebbleErrorRedirect,
    path: `/servicing/PebbleError`,
  },

  FeedbackRec: {
    component: FeedbackRec,
    path: `/servicing${serviceName}/feedback`,
  },
  FeedbackExp: {
    component: FeedbackExp,
    path: `/servicing${serviceName}/feedbackNPSForm`,
  },
  LoanTracker: {
    component: LoanTracker,
    path: `/servicing${serviceName}/loanTracker`,
  },
  Details: {
    component: Details,
    path: `/servicing${serviceName}/details`,
  },
  Feedback: {
    component: Feedback,
    path: `/servicing${serviceName}/feedbackExperience`,
  },
  NLIError: {
    component: NLIError,
    path: `/servicing${serviceName}/nliError`,
  },
  NLISuccess: {
    component: NLISuccess,
    path: `/servicing${serviceName}/nliSuccess`,
  },
  NLIDuplicateSuccess: {
    component: NLIDuplicateSuccess,
    path: `/servicing${serviceName}/nli-success`,
  },
  PropertySearch: {
    component: PropertySearch,
    path: `/servicing${serviceName}/propertySearch`,
  },
  ServiceRequest: {
    component: ServiceRequest,
    path: `/servicing${serviceName}/srRequestForm`,
  },
  GDPRdisclaimer: {
    component: GDPRdisclaimer,
    path: `/servicing/imobileservice/loadNliGdpr`,
  },
  CustomerCheck: {
    component: CustomerCheck,
    path: `/servicing/imobileservice/checkCustomer`,
  },
  GDPR: {
    component: GDPR,
    path: `/servicing/imobileservice/gdpr`,
  },
  ForexInsta: {
    component: ForexInsta,
    path: `/servicing${serviceName}/forexInstaBanking`,
  },
  ForexSubmit: {
    component: ForexSubmit,
    path: `/servicing${serviceName}/detailsResponse`,
  },
  ConfirmSR: {
    component: ConfirmSR,
    path: `/servicing${serviceName}/SRconfirmation`,
  },
  QrLogin: {
    component: QrLogin,
    path: `/servicing${serviceName}/makepayment/creditCard`,
  },
  LoanQrLogin: {
    component: LoanQrLogin,
    path: `/servicing${serviceName}/makepayment/loans`,
  },
  GridCardLogin: {
    component: GridCardLogin,
    path: `/servicing${serviceName}/gridCardLogin`,
  },
  GridCardAuthentication: {
    component: GridCardAuthentication,
    path: `/servicing${serviceName}/gridCardAuthentication`,
  },
  MultiwalletLogin: {
    component: MultiwalletLogin,
    path: `/servicing${serviceName}/prepaid`,
  },
  MultiwalletDash: {
    component: MultiwalletDash,
    path: `/servicing${serviceName}/prepaidDash`,
  },
  RekycErrorRedirect: {
    component: RekycErrorRedirect,
    path: `/servicing/rekycError`,
  },
  agentLogin: {
    component: agentLogin,
    path: `/servicing${serviceName}/agent-login`,
  },
  PanNumber: {
    component: PanNumber,
    path: `/servicing${serviceName}/panno`,
  },
  HomePage: {
    component: componentToRender(pathName),
    path: `/`,
  },
};

export default CommonRouteMap;
